import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * SEO 摘要 A/B 展示块（样式参考 H5 article）
 */
class SeoSummary extends React.PureComponent {
    static propTypes = {
        summary: PropTypes.string,
    };

    render() {
        const { summary } = this.props;

        if (!summary) {
            return null;
        }

        return (
            <section className={styles.summary} aria-label="摘要">
                <div className={styles.summaryTop}>
                    <span className={styles.summarySquare} />
                    <span className={styles.summaryLine} />
                </div>
                <p className={styles.summaryText}>{summary}</p>
                <div className={styles.summaryBottom}>
                    <span className={styles.summaryLine} />
                    <span className={styles.summarySquare} />
                </div>
            </section>
        );
    }
}

export default errorBoundary(SeoSummary);
